// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/pages/ExploreBlogTTT.jsx

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from '../components/Header';
import BlogviewTTT from '../components/Content/BlogviewTTT';
import { ProgressSpinner } from 'primereact/progressspinner';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '../css/Member.css';
import { fetchBlogContent } from '../utils/ExploreBlogTTTHandlers';

const ExploreBlogTTT = () => {
  const { pageNumber } = useParams();
  const navigate = useNavigate();

  const [ideas, setIdeas] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [pageLength, setPageLength] = useState(10);

  const currentPage = parseInt(pageNumber, 10) || 1;

  const fetchData = useCallback(async (page, length) => {
    setIsLoading(true);
    setError(null);
    try {
      const offset = (page - 1) * length;
      const response = await fetchBlogContent(length, offset);
      // รับประกันว่าโครงสร้างข้อมูลสอดคล้องกัน
      setIdeas(Array.isArray(response.posts) ? response.posts : []);
      setTotalCount(typeof response.total_count === 'number' ? response.total_count : 0);
    } catch (error) {
      console.error('Error fetching ideas:', error);
      setIdeas([]);
      setTotalCount(0);
      setError('Failed to load blog posts. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData(currentPage, pageLength);
  }, [currentPage, pageLength, fetchData]);

  const maxPage = Math.ceil(totalCount / pageLength);
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= maxPage) {
      if (newPage === 1) {
        navigate('/explore-blog-ttt');
      } else {
        navigate(`/explore-blog-ttt/currentPage/${newPage}`);
      }
    } else {
      console.warn(`Invalid page ${newPage}. Max page is ${maxPage}`);
    }
  };

  const handlePageLengthChange = (e) => {
    const newPageLength = parseInt(e.target.value, 10);
    setPageLength(newPageLength);
    handlePageChange(1);
  };

  const refreshTable = () => {
    fetchData(currentPage, pageLength);
  };

  const handleHeaderBack = () => {
    navigate(-1);
  };

  return (
    <div className="dashboard">
      <Sidebar />
      <div className="dashboard-main">
        <Header
          onBack={handleHeaderBack}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          placeholderText="Search ideas..."
          refreshData={refreshTable}
        />
        <div className="p-datatable-details">
          <div className="member-table-container">
            {isLoading ? (
              <div className="text-center my-4">
                <ProgressSpinner
                  style={{ width: '50px', height: '50px' }}
                  strokeWidth="8"
                  fill="transparent"
                  animationDuration=".5s"
                />
              </div>
            ) : error ? (
              <div className="text-center my-4 text-danger">
                {error}{' '}
                <button className="btn btn-primary ms-2" onClick={refreshTable}>
                  Try Again
                </button>
              </div>
            ) : currentPage > maxPage && maxPage > 0 ? (
              <div className="text-center my-4">
                Page {currentPage} does not exist.{' '}
                <button
                  className="btn btn-primary ms-2"
                  onClick={() => handlePageChange(1)}
                >
                  Go to Page 1
                </button>
              </div>
            ) : (
              <BlogviewTTT
                headers={ideas}
                setHeaders={setIdeas}
                totalCount={totalCount}
                searchQuery={searchQuery}
                pageLength={pageLength}
                currentPage={currentPage}
                setCurrentPage={handlePageChange}
                handlePageLengthChange={handlePageLengthChange}
                refreshData={refreshTable}
                navigate={navigate}
                hasData={ideas.length > 0}
              />

              
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreBlogTTT;